<template>
  <generic-modal :title="$t('order')" ref="generic_modal" :is_wide="true">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.name" />
            </div>
          </div>
        </div>

        <div class="column">
          <div class="field">
            <label class="label">{{ $t("tailor") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.tailor" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("expected delivery date") }}</label>
            <div class="control">
              <input
                class="input"
                type="date"
                v-model="meta.settings.delivery_date"
              />
            </div>
            <!-- <generic-calendar
              type="date"
              display_mode="dialog"
              ref="delivery_calendar"
              @selected="delivery_date_changed"
            /> -->
          </div>
        </div>
      </div>
      <div>
        <div class="container">
          <p class="buttons is-pulled-right">
            <!-- <div class="button is-secondary is-rounded" @click="add_item">
              <span class="icon">
                <i class="fa fa-plus"></i>
              </span>
              <span>{{ $t("add") }}</span>
            </div> -->
          </p>
          <h5 class="title is-5" v-if="meta.settings">{{ $t("items") }}</h5>
          <div
            v-bind:class="{ 'mt-6': iidx == 0 }"
            v-for="(item, iidx) in meta.settings.items"
            :key="iidx"
          >
            <div v-show="!item.is_editable">
              <div class="columns">
                <div class="column is-5">
                  <div class="field">
                    <label class="label" v-show="iidx == 0">{{
                      $t("product")
                    }}</label>
                    <div class="control">
                      <span
                        class="icon"
                        v-if="item.is_delivered"
                        :data-tooltip="$t('finished')"
                      >
                        <i class="fa fa-check"></i>
                      </span>
                      <span>{{ item.quantity }}</span> x
                      <span>{{ item.product_name }}</span> -
                      <span>{{ $t("size") }} {{ item.size }}</span>
                    </div>
                  </div>
                </div>
                <!-- <div class="column is-4">
                  <div class="field">
                    <label class="label" v-show="iidx == 0">{{
                      $t("product")
                    }}</label>
                    <div class="control">
                      <span>{{ item.product_name }}</span>
                    </div>
                  </div>
                </div> -->
                <!-- <div class="column is-2">
                  <div class="field">
                    <label class="label" v-show="iidx == 0">{{
                      $t("size")
                    }}</label>
                    <div class="control">
                      <span>{{ item.size }}</span>
                    </div>
                  </div>
                </div> -->
                <div class="column is-2">
                  <div class="field">
                    <label class="label" v-show="iidx == 0">{{
                      $t("unit price")
                    }}</label>
                    <div class="control">
                      <span>{{ format_currency(item.price) }}</span>
                    </div>
                  </div>
                </div>
                <div class="column is-2">
                  <div class="field">
                    <label class="label" v-show="iidx == 0">{{
                      $t("total price")
                    }}</label>
                    <div class="control">
                      <span>
                        {{ format_currency(item.price * item.quantity) }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="column is-2">
                  <div class="field">
                    <label class="label" v-show="iidx == 0">{{
                      $t("options")
                    }}</label>
                    <div class="buttons are-small">
                      <div
                        class="button"
                        @click="meta.settings.items.splice(iidx, 1)"
                      >
                        <span class="icon has-text-danger">
                          <i class="fa fa-trash"></i>
                        </span>
                      </div>
                      <div class="button" @click="start_edit_item(item, iidx)">
                        <span class="icon">
                          <i class="fa fa-edit"></i>
                        </span>
                      </div>
                      <div
                        class="button"
                        @click="set_as_delivered(item, iidx)"
                        v-if="!item.is_delivered"
                      >
                        <span class="icon">
                          <i class="fa fa-check"></i>
                        </span>
                      </div>
                      <div
                        class="button"
                        @click="unset_as_delivered(item, iidx)"
                        v-if="item.is_delivered"
                      >
                        <span class="icon">
                          <i class="fa fa-times"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="item.is_editable">
              <div class="columns">
                <div class="column is-2">
                  <div class="field">
                    <label class="label" v-show="iidx == 0">{{
                      $t("quantity")
                    }}</label>
                    <div class="control">
                      <input
                        class="input"
                        type="number"
                        v-model="meta.settings.items[iidx].quantity"
                      />
                    </div>
                  </div>
                </div>
                <div class="column is-4">
                  <div class="field">
                    <generic-dropdown
                      :title="$t('product')"
                      :show_title="iidx == 0"
                      :placeholder="$t('select one')"
                      :is_multiple="false"
                      url="/product/catalog"
                      name_field="name"
                      value_field="product_id"
                      @selected="product_changed(iidx, $event)"
                      ref="product_dropdown"
                    />
                    <!-- <label class="label" v-show="iidx == 0">{{ $t("item") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.settings.items[iidx].item"
                  />
                </div> -->
                  </div>
                </div>
                <div class="column is-2">
                  <div class="field">
                    <label class="label" v-show="iidx == 0">{{
                      $t("size")
                    }}</label>
                    <div class="control">
                      <div class="select">
                        <select
                          v-model="meta.settings.items[iidx].size"
                          class="input"
                        >
                          <option
                            :value="size"
                            v-for="(size, sidx) in sizes"
                            :key="sidx"
                          >
                            {{ size }}
                          </option>
                        </select>
                      </div>
                      <!-- <input
                        class="input"
                        type="text"
                        v-model="meta.settings.items[iidx].size"
                      /> -->
                    </div>
                  </div>
                </div>
                <div class="column is-2">
                  <div class="field">
                    <label class="label" v-show="iidx == 0">{{
                      $t("price")
                    }}</label>
                    <div class="control">
                      <input
                        class="input"
                        type="number"
                        v-model="meta.settings.items[iidx].price"
                      />
                    </div>
                  </div>
                </div>
                <div class="column is-2">
                  <div class="field">
                    <label class="label" v-show="iidx == 0">{{
                      $t("options")
                    }}</label>
                    <div class="buttons are-small">
                      <div
                        class="button"
                        @click="meta.settings.items.splice(iidx, 1)"
                      >
                        <span class="icon has-text-danger">
                          <i class="fa fa-trash"></i>
                        </span>
                      </div>
                      <div class="button" @click="end_edit_item(item, iidx)">
                        <span class="icon has-text-success">
                          <i class="fa fa-check"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error" v-html="error"></div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        :disabled="is_form_invalid"
        @click="save"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
      <div class="button is-secondary is-rounded" @click="add_item">
        <span class="icon">
          <i class="fa fa-plus"></i>
        </span>
        <span>{{ $t("add item") }}</span>
      </div>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  confirm_deletion_dialog,
  post,
  error_alert,
  format_currency,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "OrderModal",
  components: { GenericModal, GenericCalendar, GenericDropdown },
  data() {
    return {
      meta: { settings: {} },
      error: "",
      sizes: ["2", "4", "6", "8", "10", "12", "14", "16", "S", "M", "L", "XL"],
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name || !v.meta.tailor;
    },
  },
  methods: {
    format_currency,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(order_uuid) {
      let v = this;
      v.set_initial_state();

      if (order_uuid) {
        get("/tailoring_outsourcing", { uuid: order_uuid })
          .then((order) => {
            v.meta = order;
            v.$refs.generic_modal.show_modal();

            // if (order && order.settings && order.settings.delivery_date)
            //   v.$refs.delivery_calendar.set_date(order.settings.delivery_date);

            if (v.meta && v.meta.settings && v.meta.settings.items)
              v.meta.settings.items.map((item) => {
                let is_delivered = false;
                if (
                  order.tailoring_outsourcing_finished_products &&
                  order.tailoring_outsourcing_finished_products.length
                ) {
                  let target =
                    order.tailoring_outsourcing_finished_products.find(
                      (trgt) =>
                        trgt.product_id == item.product_id &&
                        trgt.size == item.size &&
                        trgt.quantity == item.quantity
                    );
                  is_delivered = target ? true : false;
                }
                item.is_delivered = is_delivered;
                return item;
              });
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      if (!v.meta.uuid)
        put("/tailoring_outsourcing", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/tailoring_outsourcing", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        tailor: "",
        settings: {
          items: [
            {
              quantity: 1,
              price: 0,
              is_editable: true,
            },
          ],
          delivery_date: "",
        },
      };
      v.error = "";
      // v.$refs.delivery_calendar.clear();
      // v.uuid = "";
    },
    add_item() {
      let v = this;
      if (v.meta.settings && !v.meta.settings.items) v.meta.settings.items = [];
      v.meta.settings.items = v.meta.settings.items.map((item) => {
        item.is_editable = false;
        return item;
      });
      v.meta.settings.items.unshift({
        quantity: 1,
        item: "",
        price: 0,
        is_editable: true,
      });

      setTimeout(() => {
        let item_count = v.meta.settings.items.length;
        if (v.$refs.product_dropdown && item_count)
          v.$refs.product_dropdown[0].clear();
      }, 100);
    },
    delivery_date_changed(date) {
      let v = this;
      v.meta.settings.delivery_date = date;
    },
    product_changed(iidx, product) {
      let v = this;
      if (product) {
        v.meta.settings.items[iidx].product_id = product.product_id;
        v.meta.settings.items[iidx].product_name = product.name;
        v.meta.settings.items[iidx].price = product.sale_price;
      }
    },
    start_edit_item(item, index) {
      let v = this;
      item.is_editable = true;
      if (
        item.product_id &&
        v.$refs.product_dropdown &&
        v.$refs.product_dropdown[index]
      )
        v.$refs.product_dropdown[index].set_value(item.product_id);
    },
    end_edit_item(item, index) {
      let v = this;
      item.is_editable = false;
    },
    set_as_delivered(item, index) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to mark as delivered?"),
        v,
        () => {
          put("/tailoring_outsourcing/product-finished", {
            order_uuid: v.meta.uuid,
            product_id: item.product_id,
            quantity: item.quantity,
            size: item.size,
          })
            .then(() => {
              item.is_delivered = true;
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    unset_as_delivered(item, index) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to mark as undelivered?"),
        v,
        () => {
          put("/tailoring_outsourcing/product-unfinished", {
            order_uuid: v.meta.uuid,
            product_id: item.product_id,
            quantity: item.quantity,
            size: item.size,
          })
            .then(() => {
              item.is_delivered = false;
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
